import React from 'react';
import { IIcon } from './icon';
import { SvgIcon } from './svgs';

const Icon = ({ type, className, viewBox = '0 0 26 26' }: IIcon) => {

	return (
		<svg
			fill="currentColor"
			className={className || ''}
			viewBox={viewBox}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg">
			<SvgIcon svgName={type as string} />
		</svg>
	);
};

export default Icon;
